import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { MediaQuery } from 'react-responsive';

export default function Header({ isHome = false }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const moreLinks = [
    { href: "https://hub.bezla.com/team", label: "Team" },
    { href: "https://hub.bezla.com/login", label: "Sign In" },
    { href: "https://rate.bezla.com/", label: "Rate.Bezla.com" },
    { href: "https://budget.bezla.com/", label: "Budget.Bezla.com" },
    { href: "http://support.bezla.com/", label: "Support.Bezla.com" },
    { href: "http://swot.bezla.com/", label: "Swot.Bezla.com" },
    { href: "https://hub.bezla.com/", label: "Hub.Bezla.com" },
    { href: "https://bezla.com/contact", label: "Contact" }
  ];

  return (
    <HeaderComponent className={`navbar sticky-top navbar-expand-lg navbar-color ${isScrolled ? 'scrolled' : ''}`} isHome={isHome}>
      <HeaderContent>
        <Overlay isOpen={isMenuOpen}>
          <div className="sticky">
            <button onClick={() => setIsMenuOpen(false)}>
              <svg viewBox="0 0 24 24" fill="#fff" width="28px" height="28px" data-ux="CloseIcon" data-edit-interactive="true" data-close="true" class="x-el x-el-svg c1-1 c1-2 c1-59 c1-1h c1-29 c1-34 c1-35 c1-36 c1-37 c1-1r c1-5a c1-5b c1-4k c1-5c c1-5d c1-5e c1-b c1-31 c1-5f c1-5g c1-5h c1-5i"><path fill-rule="evenodd" d="M17.999 4l-6.293 6.293L5.413 4 4 5.414l6.292 6.293L4 18l1.413 1.414 6.293-6.292 6.293 6.292L19.414 18l-6.294-6.293 6.294-6.293z"></path></svg>
            </button>
          </div>
          <div className="blank-space">
          </div>
          <div>
            <a href="https://bezla.com/capabilities-2">Capabilities</a>
          </div>
          <div>
            <a href="https://bezla.com/products">Products</a>
          </div>
          <div>
            <a href="https://bezla.com/insights">Insights</a>
          </div>
          <div>
            <a href="https://careers.bezla.com/jobs/Careers">Careers</a>
          </div>
          <div>
            <a href="https://bezla.com/about">About</a>
          </div>
          <div>
            <a href="https://bezla.com/team">Team</a>
          </div>
          <div>
            <a href="https://hub.bezla.com/login">Sign In</a>
          </div>
          <div>
            <a href="https://rate.bezla.com/">Rate.Bezla.com</a>
          </div>
          <div>
            <a href="https://budget.bezla.com/">Budget.Bezla.com</a>
          </div>
          <div>
            <a href="http://support.bezla.com/">Support.Bezla.com</a>
          </div>
          <div>
            <a href="http://swot.bezla.com/">Swot.Bezla.com</a>
          </div>
          <div>
            <a href="https://hub.bezla.com/">Hub.Bezla.com</a>
          </div>
          <div>
            <a href="https://bezla.com/contact">Contact</a>
          </div>
        </Overlay>
        <ImgContainer className={`${isScrolled ? 'scrolled' : ''}`}>
          <a href="https://bezla.com/">
            <img src="https://img1.wsimg.com/isteam/ip/23c01d94-28d3-425c-b0cf-5bb9e0b17e5f/Bezla.com%20LLC%20hotel%20marketing%20company%20-eb98010.png/:/rs=w:208,h:208,cg:true,m/cr=w:208,h:208/qt=q:95" alt="Bezla Logo" />
          </a>
        </ImgContainer>
        <BurguerMenu>
          <button onClick={() => setIsMenuOpen(true)}>
            <svg viewBox="0 0 24 24" fill="currentColor" width="28px" height="28px" data-ux="IconHamburger" class="x-el x-el-svg c2-1 c2-2 c2-l c2-m c2-4n c2-4o c2-4p c2-4q c2-4r c2-3 c2-4 c2-5 c2-6 c2-7 c2-8"><g><path fill-rule="evenodd" d="M4 8h16V6H4z"></path><path fill-rule="evenodd" d="M4 13.096h16v-2.001H4z"></path><path fill-rule="evenodd" d="M4 18.346h16v-2H4z"></path></g></svg>
          </button>
        </BurguerMenu>
        <Nav className="flex flex-row">
          <LinkNav href="https://bezla.com/capabilities-2" label="Capabilities" />
          <LinkNav href="https://bezla.com/products" label="Products" />
          <LinkNav href="https://bezla.com/insights" label="Insights" />
          <HiddenOnMedium>
            <LinkNav href="https://careers.bezla.com/jobs/Careers" label="Careers" />
            <LinkNav href="https://bezla.com/about" label="About" />
          </HiddenOnMedium>
          <DropdownContainer onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
            <MoreLink href="#" onClick={(e) => e.preventDefault()}>
              More
              {isDropdownOpen ? <IoIosArrowUp size={16} /> : <IoIosArrowDown size={16}/>}
            </MoreLink>
            {isDropdownOpen && (
              <DropdownMenu>
                <MediaQuery minWidth={1250}>
                  {matches => matches ? (
                    moreLinks.map((link, index) => (
                      <DropdownItem key={index}>
                        <a href={link.href}>{link.label}</a>
                      </DropdownItem>
                    ))
                  ) : (
                    <>
                      <DropdownItem>
                        <a href="https://careers.bezla.com/jobs/Careers">Careers</a>
                      </DropdownItem>
                      <DropdownItem>
                        <a href="https://bezla.com/about">About</a>
                      </DropdownItem>
                      {moreLinks.map((link, index) => (
                        <DropdownItem key={index}>
                          <a href={link.href}>{link.label}</a>
                        </DropdownItem>
                      ))}
                    </>
                  )}
                </MediaQuery>
              </DropdownMenu>
            )}
          </DropdownContainer>
        </Nav>
      </HeaderContent>
    </HeaderComponent>
  );
}

const HeaderComponent = styled.div`
  display: flex;
  width: 100%;
  height: 136px;
  flex-direction: row;
  position: absolute;
  left: 0;
  top: 0;
  align-items: center;
  justify-content: center;
  background-color: white;
  z-index: 1000;
  position: fixed;
  transition: all 0.5s ease;

  &.scrolled {
    height: 96px;
    background-color: ${props => props.isHome ? 'rgba(255, 255, 255, 0.93)' : 'white'};
  }
  
  @media (max-width: 767px) {
    height: 96px;
    &.scrolled {
      height: 66px;
    }
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    padding: 8px 24px;
    height: 96px;
    width: 100%;
    justify-content: space-between;

    &.scrolled {
      height: 80px;
      background-color: ${props => props.isHome ? 'rgba(255, 255, 255, 0.93)' : 'white'};
    }
  }
`;

const HeaderContent = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  @media (min-width: 1024px) {
    width: 936px;
  }
  @media (min-width: 1280px) {
    width: 1112px;
  }
  @media (min-width: 1535px) {
    width: 1232px;
  }
`;

const Nav = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: end;
  padding-top: 5px;

  @media (max-width: 1023px) {
    display: none;
  }
`;

const HiddenOnMedium = styled.div`
  display: flex;
  @media (max-width: 1250px) {
    display: none;
  }
`;

const LinkNav = ({ selected, label, href }) => {
  return (
    <LinkComponent
      selected={selected}
      style={{ letterSpacing: ".063em" }}
      href={href}
    >
      {label}
    </LinkComponent>
  );
};

const LinkComponent = styled.a`
  position: relative;
  display: flex;
  flex-direction: column;
  font-family: 'Noto Sans';
  font-size: 20px;
  letter-spacing: 0.063em;
  padding: 8px 6px 6px 26px;
  color: #000;
  line-height: 1.5em;
  margin-bottom: 2px;
  font-weight: 400;
  text-decoration: none;
  white-space: nowrap;

  @media (min-width: 768px) {
    font-size: 20px;
    }
  @media (min-width: 1536px) {
    font-size: 23px;
  }
`;

const ImgContainer = styled.div`
  display: flex;
  flex-direction: row;

  & img {
    width: 6.5em;
    height: 6.45rem;
  }
  &.scrolled {
    & img {
      width: 4rem;
      height: 4rem;
    }
  }

  @media (max-width: 767px) {
    padding-left: 32px;
    & img {
      width: 5rem;
      height: 5rem;
    }
    &.scrolled {
    padding-left: 32px;
      & img {
        width: 3.1rem;
        height: 3.1rem;
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    padding-left: 8px;
    & img {
      width: 5rem;
      height: 5rem;
    }
    &.scrolled {
      padding-left: 8px;
      & img {
        width: 4rem;
        height: 4rem;
      }
    }
  }
`;

const BurguerMenu = styled.nav`
  @media (min-width: 1024px) {
    display: none;
  }
  margin-right: -2px;
  & > button {
    background-color: transparent;
    border-style: solid;
    border-color: transparent;
    cursor: pointer;
  }
  @media (max-width: 767px) {
    padding-right: 24px;
  }
`;

const Overlay = styled.div`
  position: fixed;
  height: 100vh;
  width: 100%;
  background-color: rgb(22, 22, 22);
  top: 0;
  left: 0;
  z-index: 1000;
  display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
  flex-direction: column;
  color: #f7f7f7;
  overflow-y: auto;
  padding: 24px;

  & > div {
    padding: 14px 24px;
    border-bottom: 1px solid rgba(76, 76, 76, 0.5);
    &:first-child {
      border-bottom: none;
      display: flex;
      flex-direction: row-reverse;
      align-content: flex-end;

      & > button {
        position: absolute;
        top: 20px;
        right: 15px;
        background-color: transparent;
        border: none;
        cursor: pointer;
        & > img {
          width: 1.5rem;
          height: 1.5rem;
          filter: invert(100%) sepia(0%) saturate(7500%) hue-rotate(209deg)
            brightness(100%) contrast(102%);
        }
      }
    }

    & > a {
      line-height: 1.5;
      font-size: 28px;
      color: #f7f7f7;
      text-decoration: none;
      font-family: "Noto Sans", sans-serif;
      &:hover {
        font-weight: 700;
      }
    }

    &.blank-space {
      color: red;
      margin-top: 74px;
    }
      
    &.sticky {
      position: fixed;
      width: 100vw;
      height: 60px;
      top: 0;
      left: 0;
      background-color: rgb(22, 22, 22);
    }
  }
  & > div:last-child {
    border: none;
    padding-bottom: 0px;
  }
  
`;

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const MoreLink = styled.a`
  font-size: 1.125rem;
  letter-spacing: 0.063em;
  line-height: 1.5em;
  color: #000;
  font-weight: 400;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  gap: 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Noto Sans';
  padding: 8px 1px 6px 34px;
  margin-bottom: 2px;
  margin-left: -8px;
  @media (min-width: 768px) {
    font-size: 20px;
    }
  @media (min-width: 1536px) {
    font-size: 23px;
  }
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 40px;
  right: 0px;
  padding: 16px;
  background-color: rgba(255, 255, 255, 1);
  min-width: 230px;
  box-shadow: 0 3px 6px 3px rgba(0, 0, 0, 0.24);
  z-index: 1;
  border-radius: 3px;
  overflow-y: auto;
  height: auto;
  max-height: 45vh;
  @media (min-width: 1536px) {
    height: 408px;
  }
`;

const DropdownItem = styled.div`
  padding: 11px 0px;
  font-family: 'Noto Sans';
  color: #000;
  font-size: 20px;
  letter-spacing: 0.063em;
  
  & > a {
    color: black;
    text-decoration: none;
    display: block;
    font-weight: 400;
    line-height: 1.5rem;
  }

  @media (min-width: 768px) {
    font-size: 20px;
  }

  @media (min-width: 1536px) {
    font-size: 23px;
    padding: 13px 0px;
  }
`;